module.exports = __webpack_public_path__ + "static/media/world.6f0fde3b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/world.svg
// module id = 1048
// module chunks = 0